import { useEffect } from "react";

export function useOnClickOutside(ref: any, handler: Function) {
  useEffect(
    () => {
      const HandleClickOutside = (event: Event) => {
        // Do nothing if clicking ref's element or descendent elements
        if (!ref.current ||
          ref.current.contains(event.target) ||
          event.composedPath().includes(ref.current)) {
          return;
        }
        handler(event);
      };

      const HandleKeyPress = (event: KeyboardEvent) => {
        if (event.key === "Escape") {
          handler(event);
        }
      };

      document.addEventListener("keydown", HandleKeyPress);
      document.addEventListener("mousedown", HandleClickOutside);
      document.addEventListener("touchstart", HandleClickOutside);
      return () => {
        document.removeEventListener("keydown", HandleKeyPress);
        document.removeEventListener("mousedown", HandleClickOutside);
        document.removeEventListener("touchstart", HandleClickOutside);
      };
    },
    // Add ref and handler to effect dependencies
    // It's worth noting that because passed in handler is a new ...
    // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
    [ref, handler]
  );
}
